import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createSuper";
import { AnimationOptions } from "../../AnimationOptions";
export var SizeAnimation = /*#__PURE__*/function (_AnimationOptions) {
  _inherits(SizeAnimation, _AnimationOptions);
  var _super = _createSuper(SizeAnimation);
  function SizeAnimation() {
    var _this;
    _classCallCheck(this, SizeAnimation);
    _this = _super.call(this);
    _this.destroy = "none";
    _this.enable = false;
    _this.speed = 5;
    _this.startValue = "random";
    _this.sync = false;
    return _this;
  }
  _createClass(SizeAnimation, [{
    key: "size_min",
    get: function get() {
      return this.minimumValue;
    },
    set: function set(value) {
      this.minimumValue = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _a;
      if (data === undefined) {
        return;
      }
      _get(_getPrototypeOf(SizeAnimation.prototype), "load", this).call(this, data);
      if (data.destroy !== undefined) {
        this.destroy = data.destroy;
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      this.minimumValue = (_a = data.minimumValue) !== null && _a !== void 0 ? _a : data.size_min;
      if (data.speed !== undefined) {
        this.speed = data.speed;
      }
      if (data.startValue !== undefined) {
        this.startValue = data.startValue;
      }
      if (data.sync !== undefined) {
        this.sync = data.sync;
      }
    }
  }]);
  return SizeAnimation;
}(AnimationOptions);